import { FC } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { CarbonSnapResultsResponse } from "../../../../../datasources/carbonsnap/io/response";

interface Props {
	transportData: CarbonSnapResultsResponse["transportData"];
}

const TransportDataSection: FC<Props> = ({ transportData }) => {
	const { t } = useTranslation("feature.carbonsnap");

	const formatBoolean = (value: boolean): string => {
		return value ? t("results/data/yes") || "Sì" : t("results/data/no") || "No";
	};

	return (
		<Box>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{t("results/data/title") || "Dati Trasporto"}
			</Typography>
			<Paper sx={{ p: 3 }}>
				<Grid container spacing={3}>
					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/total distance") || "Distanza totale"}
						</Typography>
						<Typography variant="h6">
							{transportData.totalDistance.value} {transportData.totalDistance.measure}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/cargo weight") || "Peso merce"}
						</Typography>
						<Typography variant="h6">
							{transportData.cargoWeight.value} {transportData.cargoWeight.measure}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/intermodal") || "Intermodale"}
						</Typography>
						<Typography variant="h6">
							{formatBoolean(transportData.isIntermodal)}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/calculation mode") || "Modalità di calcolo"}
						</Typography>
						<Typography variant="h6">
							{transportData.calculationMode}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/trips") || "Nr. viaggi"}
						</Typography>
						<Typography variant="h6">
							{transportData.numberOfTrips}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/departure date") || "Data partenza"}
						</Typography>
						<Typography variant="h6">
							{dayjs(transportData.departureDate).format("DD/MM/YYYY")}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/temperature") || "Temperatura"}
						</Typography>
						<Typography variant="h6">
							{transportData.temperature}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</Box>
	);
};

export default TransportDataSection;
